import { createWebWorker } from '../createWebWorker/createWebWorker';
export var getBase64Image = createWebWorker(function (self, file) {
    if (!(file instanceof Blob))
        throw new Error("file is not typeof Blob ".concat(typeof file));
    var fileReader = new FileReader();
    fileReader.readAsDataURL(file);
    fileReader.onload = function (readerEvent) {
        var _a;
        if ((_a = readerEvent === null || readerEvent === void 0 ? void 0 : readerEvent.target) === null || _a === void 0 ? void 0 : _a.result) {
            var result = readerEvent.target.result;
            self.postMessage(result);
        }
    };
}, window);
